module.exports = __webpack_public_path__ + "img/huliyongpin_shrz.f545da1a.png";